
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import FormField from '@/components/forms/FormField.vue';
import { Form } from 'vee-validate';
import { ProfileSchema } from '@/schemas/profile.schema';
import { Actions, Getters } from '@/store/enums/SystemEnums';
import {
  Actions as AuthActions,
  Getters as AuthGetters,
} from '@/store/enums/AuthEnums';
import AddressForm from '@/components/forms/AddressForm.vue';
import maskUtil from '@/utils/mask';
import toasts from '@/utils/toasts';

const initialValues = {
  first_name: '',
  last_name: '',
  email: '',
  date_of_birth: '',
  state: '',
  country: 'AU',
} as any;

export default defineComponent({
  name: 'profile-update',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['formSubmmitted', 'editMode'],
  data: () => ({
    // eslint-disable-next-line
    options: [] as any,
    loading: false,
    formData: initialValues,
    form: {} as unknown as typeof Form,
  }),
  mounted() {
    this.form = this.$refs.profileForm as typeof Form;
  },
  components: {
    FormField,
    Form,
    AddressForm,
  },
  computed: {
    ...mapGetters({
      actionError: AuthGetters.GET_AUTH_USER_ACTION_ERROR,
      getStates: Getters.GET_LIST_STATES,
    }),
    formSchema() {
      return ProfileSchema;
    },
    maskingMobile() {
      return maskUtil.mobile.aus;
    },
    initValues() {
      return this.profile
        ? {
            ...this.profile,
            ...{
              country: this.profile.country ?? 'AU',
            },
          }
        : initialValues;
    },
  },
  methods: {
    ...mapActions({
      updateProfile: AuthActions.UPDATE_USER_PROFILE,
      listStates: Actions.LIST_STATES,
    }),
    disabledDates(time: Date) {
      return time.getTime() > Date.now();
    },
    handleCountryChange(value) {
      this.listStates(value);
      this.setFieldValue('country', value);
    },
    handleCountryBlur() {
      this.validateFormField('country');
    },
    handleStateChange(value) {
      this.setFieldValue('state', value);
    },
    handleStateBlur() {
      this.validateFormField('state');
    },
    submitForm(values) {
      if (this.loading) return;
      this.loading = true;

      this.formData = {
        ...this.formData,
        ...values,
      };

      // // remove unrelated pre-filled formData
      delete this.formData.business_id;
      delete this.formData.business_name;
      delete this.formData.business_phone_number;
      delete this.formData.business_logo;
      delete this.formData.business_mobile_number;
      delete this.formData.business_email_address;
      delete this.formData.business_address_line;
      delete this.formData.business_city;
      delete this.formData.business_country;
      delete this.formData.business_state;
      delete this.formData.business_post_code;
      delete this.formData.business_color;
      delete this.formData.business_text_color;
      delete this.formData.business_website;
      // // end:: remove unrelated pre-filled formData

      this.updateProfile(this.formData)
        .then(() => {
          toasts.success('Profile Successfully Updated');
          this.$emit('formSubmmitted');
        })
        .catch(() => {
          if (this.actionError) {
            const { errors, message } = this.actionError;
            toasts.error(errors, message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFieldValue(field, value) {
      if (!this.form.setFieldValue) return;

      this.form.setFieldValue(field, value);
    },
    validateFormField(field) {
      if (!this.form.validateField) return;

      this.form.validateField(field);
    },
    cancel() {
      this.$emit('editMode', false);
    },
  },
});
